import React from 'react';
import FormInput from 'Components/FormInput';
import TegLogoIcon from 'Icons/T_EG.jpg';
import { connect } from 'react-redux';
import ActionLoader from 'Components/ActionLoader/index';
import { CHANGE_PASSWORD_DETAILS} from 'Constants/actionConstants';
import { getToken, getCompanyType , getUser, deleteToken} from 'Utils/storage';
import RCG from 'react-captcha-generator';
import { Link } from 'react-router-dom';
import Recaptcha from 'react-recaptcha';
import { logOutWithToken } from 'Utils/api';

class ResetPassword extends React.Component {

    constructor(props) {
        super(props);
        this.state = {
            oldPassword:"",
            newPassWord:"",
            confirmPassword:"",
            companyType:getCompanyType(),
            isVerified:false,
            errorMessage:"",
            showTag:false
        }
    }

    onChange = (e)=> {
        this.setState({
            [e.target.name]: e.target.value
        })
      }
      componentDidMount() {
        setTimeout(function() { //Start the timer
          this.setState({showTag: true}) //After 1 second, set render to true
      }.bind(this), 1000)
      }
      changePassword = (e)=> {
          const userDetails= getUser();
        const { dispatch, history } = this.props;
        const { oldPassword,newPassword, confirmPassword,companyType} = this.state;
        dispatch({
            type: CHANGE_PASSWORD_DETAILS,
            data: {
                oldPassword,
                newPassword,
                confirmPassword,
                token: getToken(),
                companyType,
                email:userDetails.email,
                id:userDetails.id
            },
            onSuccess: ((data) => {
                if(data.status===200){
                  logOutWithToken();
                    // deleteToken();
                    // history.push('/');
                }
            })
        })
      }

      validatePassword=()=>{
        let isValidPasswordLength=true;
        let { errorMessage } = this.state;
        let isEmptyData=(this.state.newPassword===undefined || this.state.oldPassword===undefined ||this.state.confirmPassword===undefined);
        errorMessage=isEmptyData?"Please Enter All Fileds!!":"";

        if(!isEmptyData){
          isValidPasswordLength= (this.state.newPassword.length<6 || this.state.confirmPassword.length<6);
          errorMessage=isValidPasswordLength?"Password Should Be Minimum 6 Characters!!":"";
        }
        if(!isValidPasswordLength){
            errorMessage= (this.state.newPassword!==this.state.confirmPassword)?"New Password And Confirm Password Does Not Match!!":"";
        } 
        if((this.state.oldPassword=="")){
            errorMessage=(this.state.oldPassword=="")?"Please Enter Current Password!!":"";
        }
        if(this.state.newPassword===this.state.oldPassword){
            errorMessage="New Password And Current Password Cannot Be The Same!!"
        }
        const mediumRegex = new RegExp("^((?=.*\\d)(?=.*[a-z])(?=.*[A-Z])(?=.*[!@#$%]).{6,})");
        if (!mediumRegex.test(this.state.newPassword) || !mediumRegex.test(this.state.confirmPassword)) {
          errorMessage="Password Should Contain Minimum 6 Characters With 1 Uppercase Letter, 1 Lowercase Letter, 1 Number And 1 Special Character.";
        }
      //  if (this.state.actualCaptcha !== this.state.captchaEntered) {
        //  errorMessage="Invalid Captcha entered." 
        //}
        if(!this.state.isVerified){
          errorMessage="Please Verify You Are Not Robot" ;
        }
        if(errorMessage && errorMessage.length > 0){
            // this.state.errorMessage
            this.setState({
                errorMessage: errorMessage
            });
            return false;
        }
        return true;
       }
       verifyCallback =  (response)=> {
       if(response){
        this.setState({
          isVerified:true
         });
         this.setState({
          errorMessage:""
         });
       }
      };
      formSubmit = (e)=> { 
        e.preventDefault(); 
        {this.validatePassword()?this.changePassword():""}    
      }

     // result = (text) => { this.setState({ actualCaptcha: text }) }
    

    render() {
        const url= this.state.companyType===1?"/seeker":"/transporters";
        
        return(
         <form  onSubmit = {this.formSubmit} className="ResetPasswordForm">   
         { this.props.changePswdSubmitting && <ActionLoader /> }
             <div className="wt-350 center pr mt-170 pt-50"> 
            <div className="form pt-50 flex flex-column" onSubmit = {this.formSubmit}>
             <div className="tCenter flex flex-center pt-50 pb-10 flex-self-center">
                <div style={{ backgroundImage: `url(${TegLogoIcon})`, backgroundRepeat: 'no-repeat', backgroundSize: 'contain', width: '240px', height: '70px', marginBottom: '10px' }} />
            </div>
            <FormInput containerClassName="mb-10" name="oldPassword" type="password" value={this.state.oldPassword} placeholder="Current Password" onChange={this.onChange}/>
             <FormInput containerClassName="mb-10" name="newPassword" type="password" value={this.state.newPassword} placeholder="New Password" onChange={this.onChange} onBlur={this.fieldPswdValidation}/>
             
             <FormInput containerClassName="mb-10" name="confirmPassword" type="password" value={this.state.confirmPassword} placeholder="Confirm Password" onChange={this.onChange} onBlur={this.fieldPswdValidation}/>
              
                    {this.state.showTag && <Recaptcha
                sitekey="6LcHtbwUAAAAAKkjbo7nNh9ajzF5GEHk9uC5skGG"
                render="explicit"
                verifyCallback={this.verifyCallback}
              />} 
             <br></br>
             <br></br>
             
             <div className="flex flex-right mb-30 mt--20">
                <Link to={url} ><span className="theme-color fs-12 fSemibold curP" >Cancel</span></Link>
                </div>
             <div className="error-color">{this.state.errorMessage}</div>
             <input type="submit" className="ht-40 br-20 white-color bg-theme fs-16 fBold pl-30 pr-30" value="Change Password"/> 
             </div>
             </div>
         </form>

        );
      }

}

const mapStateToProps = ({authentication}) => {
    return {
      changePswdSubmitting: authentication.changePassword.isLoading,
    }
  };
export default connect(mapStateToProps)(ResetPassword);